import { cn } from "@/lib/utils";
import { Icon } from "./icon";

export interface SortHeaderProps {
  /** Column header text. */
  label: string;
  /** This column's sort key (passed back to onSort). */
  field: string;
  /** Whether this column is the active sort. */
  active: boolean;
  /** Active sort direction (only meaningful when `active`). */
  dir: "asc" | "desc";
  /** Click handler — the caller toggles direction / switches column + resets the page. */
  onSort: (field: string) => void;
}

/**
 * A sortable `<th>` for server-sorted tables: a button rendering the label + a direction caret.
 * The caret is faint until this column is the active sort, then highlighted and flipped for asc
 * (the base `chevD` points down = descending). Direction logic + page reset live in the caller.
 */
export function SortHeader({ label, field, active, dir, onSort }: SortHeaderProps) {
  return (
    <th className="th-sort" aria-sort={active ? (dir === "asc" ? "ascending" : "descending") : "none"}>
      <button type="button" className={cn("sort-btn", active && "active")} onClick={() => onSort(field)}>
        {label}
        <Icon name="chevD" size={13} className={cn("sort-arrow", active && dir === "asc" && "asc")} />
      </button>
    </th>
  );
}
